import * as AppTrackingEvents from 'app/constants/AppTrackingEvents';
import ButtonSimple from 'app/ui/buttons/ButtonSimple';
import Hud from 'app/ui/Hud';
import { createTextField } from 'utils/Text';
import { FONT_TITLE, FONT_COLOUR_SCORE, FONT_COLOUR_LEVEL_WIN, FONT_COLOUR_STROKE } from 'app/constants/AppConstants';
import { GAME_SFX_GAME_COMPLETE, GAME_SFX_PATTY } from 'app/constants/GameSFX';

class GameEnd extends Phaser.State {
  init({ character }) {
    this.character = character;
  }

  preload(game) {}

  create(game) {
    this.game = game;

    this.background = game.make.sprite(0, 0, 'bg_game_complete');
    this.background.anchor.set(0.5, 0.5);
    this.background.position.set(0, this.game.height);
    this.game.add.existing(this.background);

    this.container = game.add.group();

    this.createCharacters();

    this.copy = createTextField(this.game, FONT_TITLE, 84, FONT_COLOUR_LEVEL_WIN);
    this.copy.stroke = FONT_COLOUR_STROKE;
    this.copy.strokeThickness = 6;
    this.copy.text = this.game.copy.getCopy('game') + ' ' + this.game.copy.getCopy('complete');
    this.copy.anchor.set(0.5);
    this.copy.setShadow(3, 3, 'rgba(0,0,0,0.5)', 0);
    this.copy.position.set(this.game.width * 0.5, this.game.height * 0.2);

    this.game.add.existing(this.copy);

    this.game.windowEventController.handleWindowResize();
    this.game.scale.onSizeChange.add(this.positionContainer, this);
    this.positionContainer();

    this.game.hud.activate({ id: Hud.GAMEEND });
    this.game.hud.fadeIn();

    this.game.sounds.playSFX(GAME_SFX_GAME_COMPLETE, { delay: 2600 });
    this.game.sounds.playSFX(GAME_SFX_PATTY);
  }

  createCharacters() {
    this.apple = this.game.make.sprite(0, 0, 'apple_endings', 'apple_complete_0001');
    this.apple.animations.add('win', Phaser.Animation.generateFrameNames('apple_complete_', 0, 29, '', 4), 24, true);
    this.apple.anchor.set(0.5, 1);
    this.apple.position.set(800 - this.background.width / 2, 480 - this.background.height / 2);
    this.apple.scale.set(0.54);
    this.apple.play('win');

    this.onion = this.game.make.sprite(0, 0, 'onion_endings', 'onion_complete_0001');
    this.onion.animations.add('win', Phaser.Animation.generateFrameNames('onion_complete_', 0, 30, '', 4), 24, true);
    this.onion.anchor.set(0.5, 1);
    this.onion.position.set(465 - this.background.width / 2, 480 - this.background.height / 2);
    this.onion.scale.set(0.54);
    this.onion.play('win');

    //ms patty
    this.patty = this.game.make.spine(0, 0, 'patty');
    this.patty.setAnimationByName(0, 'Dance', true);
    this.patty.anchor.set(0.5, 1);
    this.patty.position.set(620 - this.background.width / 2, 480 - this.background.height / 2);

    //
    this.background.addChild(this.onion);
    this.background.addChild(this.patty);
    this.background.addChild(this.apple);
  }

  positionContainer() {
    const x = 0;
    const y = 0;
    this.container.position.set(x, y);

    this.background.scale.set(Math.max(this.game.height / this.game.defaultHeight, this.game.width / this.game.defaultWidth));
    this.background.position.set(this.game.width * 0.5, this.game.height * 0.5);

    let scale = Math.max(this.game.height / this.game.defaultHeight, this.game.width / this.game.defaultWidth);
    let yOffset = 1 - scale;
    yOffset /= 4;

    this.copy.position.set(this.game.width * 0.5, this.game.height * (0.2 + yOffset));
  }

  update() {
    this.patty.update();
  }

  shutdown(game) {
    game.scale.onSizeChange.remove(this.positionContainer, this);

    // destroy
    this.background.destroy(true);
    this.container.destroy(true);
    this.apple.destroy(true);
    this.onion.destroy(true);
    this.patty.destroy(true);
    this.copy.destroy(true);

    // clear up
    this.background = null;
    this.container = null;
    this.apple = null;
    this.onion = null;
    this.patty = null;
    this.copy = null;
  }
}

export default GameEnd;
